import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon } from "../../../locales";
import { CardServer } from "../../../server";
import { generateOperationFormConfig } from './config'

const server = CardServer.Holder

const DEFAULT_OPERATION_DATA = {
    Id: null,
    Email: null,
    PhoneNumber: null
}

type OperateModeType = 'update'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess, options } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('update');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...val
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.update, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.operateSuccess);
            changeVisible(false);
            onSuccess?.();
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode, options });
    }, [formData, mode, options]);

    return (
        <div>
            <Modal
                title={'修改持卡人信息'}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Id, Email, PhoneNumber } = formData
                    const params = {
                        Id,
                        Email,
                        PhoneNumber
                    }
                    run(params)
                }}
            >
                <EditForm
                    componentId="card-product-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 18 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
